import { useEffect } from "react";

// Auto-expands a collapsed card the first time an unseen alert id shows up.
export function useAutoExpandNew(ids, storageKey, setOpen) {
  useEffect(() => {
    if (!ids.length) return;
    let seen = [];
    try {
      seen = JSON.parse(localStorage.getItem(storageKey) || "[]");
    } catch {
      seen = [];
    }
    if (ids.some((id) => id && !seen.includes(id))) {
      setOpen(true);
      const merged = [...new Set([...seen, ...ids])].slice(-100);
      try {
        localStorage.setItem(storageKey, JSON.stringify(merged));
      } catch {
        /* storage full/unavailable */
      }
    }
  }, [ids.join("|")]); // eslint-disable-line react-hooks/exhaustive-deps
}
